import { render, staticRenderFns } from "./HighlightedArticles.vue?vue&type=template&id=d9d2ef24&"
import script from "./HighlightedArticles.vue?vue&type=script&lang=js&"
export * from "./HighlightedArticles.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedArticles.vue?vue&type=style&index=0&id=d9d2ef24&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports